<template>
  <div class="capitalflow">
    <div class="hander">
      <div class="hander1">
        <van-icon name="arrow-left" @click="goBack" class="nav_goback" />
      </div>
      <div class="date" @click="show=true">
        <span class="t1">{{ date }}</span>
        <div class="next">></div>
      </div>
      <div class="all">
        <span class="t1">收入:￥{{mydata.income}}</span>
        <span class="t1">支出:￥{{ mydata.exp }}</span>
      </div>
    </div>
    <div v-if="!list.length" style="padding-top:200px;color:#999;text-align:center;font-size:18px;">暂无数据</div>

    <div class="item" v-for="item in list" :key="item.id">
      <div class="bottom">
        <div class="left">
          <span class="t1">{{ item.type_title }}</span>
          <span class="t2"></span>
        </div>
        <div class="right">
          <span class="t1">{{ item.money > 0 ? '+'+item.money:item.money }}</span>
          <span class="t2">可用余额：{{ item.balance }}</span>
        </div>
      </div>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        @confirm="selDate"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import toTime from "../../assets/js/util";
export default {
  data() {
    return {
      show: false,
      currentDate: new Date(),
      date: "2019-08",
      list: []
    };
  },
  computed: {
    mydata() {
      let list = this.list;
      let income = 0;
      let exp = 0;
      list.forEach(item => {
        if (item.money < 0) {
          exp += item.money * 100;
        } else {
          income += item.money * 100;
        }
      });
      return {
        exp: exp / 100,
        income: income / 100
      };
    }
  },
  created() {
    this.date = toTime.formatTimeTwo(new Date(), "Y-M");
    this.getBalanceList();
  },
  methods: {
    selDate(e) {
      console.log(e);
      let date = new Date(e);
      let year = date.getFullYear();

      let m = date.getMonth();
      let month = m > 8 ? m + 1 : '0' + (m + 1);
      console.log(month)

      this.date = year + "-" + month;
      this.getBalanceList();
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
    getBalanceList() {
      this.$http({
        url: "myBalanceList",
        data: {
          mouth: this.date
        }
      }).then(res => {
        this.list = res;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.capitalflow {
  .hander1 {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.6);
    margin-bottom: 10px;
    color: #666;
  }
  
  .hander {
    width: 100%;
    height: 106px;
    box-sizing: border-box;
    padding: 0 24px;
    display: flex;
    align-items: center;
    color: #666;
    // justify-content: space-between;
    
    
    .date {
      display: flex;
      align-items: center;
      color: #666;
      width: 200px;
      height: 60px;
      border-radius: 30px;
      .t1 {
        font-size: 30px;
        
      }
      .next {
        font-size: 30px;
        transform: scaleX(1.9) rotateZ(90deg);
        margin-left: 20px;
      }
    }
    .all {
      flex: 1;
        text-align: right;
      .t1 {
        font-size: 24px;
        color: #666;
        display: block;
    
      }
    }
  }
  .item {
    background-color: #fff;
    margin-bottom: 2px;
    .bottom {
      width: 100%;
      height: 125px;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        span {
          display: block;
        }
        .t1 {
          font-size: 30px;
          color: #333;
          margin-bottom: 10px;
        }
        .t2 {
          font-size: 24px;
          color: #999;
        }
      }
      .right {
        span {
          display: block;
          text-align: right;
        }
        .t1 {
          font-size: 30px;
          color: #e42129;
          margin-bottom: 10px;
        }
        .t2 {
          font-size: 24px;
          color: #999;
        }
      }
    }
  }
}
</style>
